import { z } from 'zod';

/** Quellen der Rohdaten ([A] 2.3, E-p21). */
export const RAW_RECORD_SOURCES = [
  'dma.changelog',
  'dma.snapshot',
  'm365.mail_meta',
  'm365.mail_radar',
  'odoo.json2',
] as const;
export const RawRecordSourceSchema = z.enum(RAW_RECORD_SOURCES);
export type RawRecordSource = z.infer<typeof RawRecordSourceSchema>;

/** Snapshot-Domänen der DMA-Member-Data-Portability-API (case-sensitiv). */
export const SNAPSHOT_DOMAINS = [
  'PROFILE',
  'CONNECTIONS',
  'INVITATIONS',
  'INBOX',
  'ALL_LIKES',
  'ALL_COMMENTS',
  'MEMBER_SHARE_INFO',
  'ARTICLES',
] as const;
export const SnapshotDomainSchema = z.enum(SNAPSHOT_DOMAINS);
export type SnapshotDomain = z.infer<typeof SnapshotDomainSchema>;

const M365_FOLDER = /^[a-z][a-z0-9_-]{0,63}$/;
const ODOO_MODEL = /^[a-z][a-z0-9_.]{0,63}$/;
const STREAM_ID = new RegExp(
  `^(?:changelog|snapshot:(?:${SNAPSHOT_DOMAINS.join('|')})|m365:folder:[a-z][a-z0-9_-]{0,63}|odoo:[a-z][a-z0-9_.]{0,63})$`,
);

/** `changelog` | `snapshot:<SnapshotDomain>` | `m365:folder:<name>` | `odoo:<model>`. */
export const StreamIdSchema = z.string().regex(STREAM_ID);
export type StreamId = z.infer<typeof StreamIdSchema>;

export const CHANGELOG_STREAM_ID: StreamId = 'changelog';

/** Strom-ID einer Snapshot-Domäne; wirft bei ungültiger Domäne (Programmierfehler). */
export function snapshotStreamId(domain: SnapshotDomain): StreamId {
  return StreamIdSchema.parse(`snapshot:${SnapshotDomainSchema.parse(domain)}`);
}

/** Strom-ID eines Microsoft-365-Ordners; wirft bei ungültigem Namen. */
export function m365FolderStreamId(name: string): StreamId {
  return StreamIdSchema.parse(`m365:folder:${z.string().regex(M365_FOLDER).parse(name)}`);
}

/** Strom-ID eines Odoo-Modells; wirft bei ungültigem Modellnamen. */
export function odooStreamId(model: string): StreamId {
  return StreamIdSchema.parse(`odoo:${z.string().regex(ODOO_MODEL).parse(model)}`);
}
